import React from 'react';
import { Route, NotFound } from 'cccisd-laravel-boilerplate';
import defaultProps from 'recompose/defaultProps.js';
import { Switch } from 'react-router-dom';
import { AdminRoutes, Manage as AppdefManage } from 'cccisd-laravel-appdefs';
import { AuthRedirect } from 'cccisd-laravel-nexus';
import { Quest } from 'cccisd-laravel-assignment';
import { ResourceCenter } from 'cccisd-laravel-resources';

// Layouts
import MainLayout from './layouts/MainLayout';
import QuestLayout from './layouts/QuestLayout';

// Pages
/* eslint-disable import/no-extraneous-dependencies, import/no-unresolved */
import Welcome from './pages/Welcome'; // Include it into main bundle
import Dashboard from './pages/Dashboard';
import Administer from './pages/Administer';
import TakeSurvey from './pages/TakeSurvey';
import UpdateProfile from './pages/UpdateProfile';
import ViewData from './pages/ViewData';

// Laravel packages
import Nexus from 'bundle-loader?lazy!cccisd-laravel-nexus';

// Bind MainLayout by default
const AppRoute = defaultProps({ layout: MainLayout })(Route);

const MainLayoutFluid = defaultProps({ className: 'container-fluid' })(MainLayout);
const MainLayoutSecondaryNav = defaultProps({ showSecondaryNav: true })(MainLayout);
const MainLayoutFluidSecondaryNav = defaultProps({
    className: 'container-fluid',
    showSecondaryNav: true,
})(MainLayout);

let Fortress = window.cccisd.fortress;
let AppDefinitions = window.cccisd.appDefs;

const componentMatch = {
    AppdefManage,
    Welcome,
    Dashboard,
    Administer,
    TakeSurvey,
    ViewData,
    ResourceCenter,
};

const layoutMatch = {
    MainLayout,
    MainLayoutFluid,
    MainLayoutSecondaryNav,
    MainLayoutFluidSecondaryNav,
};

export default () => (
    <Switch>
        {AppDefinitions.routes.map(route => {
            const role = window.cccisd.fortress.user.acting.role.handle;
            const Component = componentMatch[route.componentHandle];

            // careCoordinator and supervisor tabs access
            if (role === 'careCoordinator' || role === 'supervisor') {
                const { administerPageAccess, dashboardPageAccess, managePageAccess } =
                    window.cccisd.fortress.user.acting.role_data;

                const tabsAccess = {
                    administer: administerPageAccess,
                    dashboard: dashboardPageAccess,
                    manage: managePageAccess,
                };

                const accessValue = tabsAccess[route.handle];
                if (accessValue !== undefined && accessValue !== null && !accessValue) {
                    return null;
                }

                if (!Component) {
                    return null;
                }
            } else if (!Component) {
                return null;
            }

            return (
                <AppRoute
                    key={route.handle}
                    path={route.url}
                    component={Component}
                    componentProps={route.componentProps}
                    exact
                    layout={
                        'layout' in route && layoutMatch[route.layout] ? layoutMatch[route.layout] : MainLayoutFluid
                    }
                />
            );
        })}
        <AppRoute path="/" component={Welcome} exact />
        <AppRoute path="/welcome" component={Welcome} />

        <AppRoute
            path={['/cg/:sessionId/:deploymentHash/:respondentHash', '/y/:sessionId/:deploymentHash/:respondentHash']}
            component={TakeSurvey}
            layout={MainLayout}
        />
        <AppRoute path={['/quest/preview', '/d', '/survey']} component={Quest} layout={QuestLayout} />

        {/* Laravel packages routes */}
        {AdminRoutes(MainLayoutFluid)}

        {Fortress.auth() && (Fortress.user.acting.role.handle === 'uberadmin' || Fortress.isSuperUser()) && (
            <AppRoute path="/ViewData" />
        )}

        <Route path="/account/profile/:pawnId?/:pawnHash?" component={UpdateProfile} layout={MainLayoutFluid} />

        <AppRoute
            path="/account"
            layout={null}
            component={Nexus}
            componentProps={{ defaultLayout: MainLayout, registrationSurveyLayout: QuestLayout }}
        />

        <AppRoute path={Fortress.settings.config.after_login_url} component={AuthRedirect} exact />

        {/* Not found page */}
        <AppRoute component={NotFound} />
    </Switch>
);
